// extracted by mini-css-extract-plugin
export default {"cardsHeading":"TrainingProgram_cardsHeading__t3dO9"};